import React from "react"
import { Layout, Row, Col, Card, Typography } from 'antd'
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import LogoWhite from '../../Images/logo_white.png'
const { Content } = Layout;
const { Title } = Typography;

class StepsUserFormBase extends React.Component {
    
    render() {
        return (
            <Layout>
                <Content>
                    <Row type="flex" justify="space-around" align="middle" style={{ minHeight: "100vh", background: "#353FDF" }}>
                        <Col xs={22}
                            sm={20}
                            lg={18}>
                            <center>
                                <img alt="error" src={LogoWhite} className="error-checkout"style={{ marginBottom: "15px", marginTop: "15px" }}  />
                            </center>    
                            {
                                // Hago esto para identificar el primer step, necesitaba modificar estilos solo en dos steps
                                // Como no tiene titulo fue necesario mandar ' '
                                this.props.title === ' ' &&
                                <Card style={{
                                    backgroundColor: "#353FDF",
                                    borderColor: "#353FDF",
                                    height: "auto", textAlign: "center",
                                    }}>
                                        <Title level={2} style={{ color: 'white',marginBottom: "10px" }}><b>{this.props.title}</b></Title>
                                        {this.props.children}
                                </Card>
                                
                            }
                            {
                                this.props.title !== ' ' && 
                                <Card style={{
                                    // backgroundColor: "#353FDF",
                                    borderRadius: "5px", height: "auto", textAlign: "center", marginTop: "5px", paddingTop: "40px",
                                    paddingBottom: "20px", marginBottom:'5px', borderTop: '#ffffff' 
                                    }}>
                                        <Title level={2} style={{ marginBottom: "40px" }}><b>{this.props.title}</b></Title>
                                        {this.props.children}
                                </Card>
                            }
                        </Col>
                    </Row>
                </Content>
            </Layout>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StepsUserFormBase));